
import UpdateTransportation from "components/ManageTransportaition/UpdateTransportation";
import NotFooterLayout from "layouts/NotFooterLayout";
import { useParams } from "react-router-dom";
 

function UpdateTransportationPage() {
  const { id } = useParams<{ id: string }>();
  return (
    <NotFooterLayout namePage="แก้ไขขนส่ง" >
      <div className="layout-content">
        <UpdateTransportation id={id ?? ''} />
      </div>
    </NotFooterLayout>
  );
}

export default UpdateTransportationPage;